import React, { useEffect, useRef } from "react";
import LoadingControl from "../common/LoadingControl";
import { useLoading } from "../common/LoadingContext";

const LoadingTopicCard = ({ height = null, compact = false }) => {
  const { setIsLoading } = useLoading();
  const parentRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    return () => {
      setIsLoading(false);
    };
  }, [setIsLoading]);

  return (
    <div
      className={`card-glass ${height ? "" : "h-full"} ${
        compact ? "p-3 px-4" : ""
      }`}
      style={height ? { height } : {}}
      ref={parentRef}
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center mb-2">
          <div className="flex items-center h-[54px]">
            <h3
              className={`${
                compact ? "text-lg" : "text-xl"
              } font-semibold text-gray-100 text-pretty`}
            ></h3>
          </div>
        </div>
        <div className="relative group flex-grow">
          <p
            className={`text-gray-300 mb-4 line-clamp-3 overflow-hidden ${
              compact ? "text-xs" : ""
            }`}
          ></p>
          <div className={`hint-glass ${compact ? "text-xs" : ""}`}></div>
        </div>
        <div className="mt-auto">
          {!compact && <div className="grid grid-cols-2 gap-1 mb-4"></div>}
          <div className="flex flex-wrap mt-2 min-h-8"></div>
        </div>
        <LoadingControl />
      </div>
    </div>
  );
};

export default LoadingTopicCard;
